module.exports = __webpack_public_path__ + "img/plan.a0794af5.svg";